import React, { useState } from "react";
import { Close, InfoOutlined } from "@mui/icons-material";
import TextMAS from "components/TextMAS/TextMAS";
import { Box, Stack } from "@mui/material";
import useColors from "utils/useColors/useColors";

/**
 * @param {object} props 
 * @param {string} props.title
 * @param {boolean} props.closable
 * @param {() => void} props.onClose
 * @param {React.ReactNode} props.children
 */
const NoticeBox = ({ title, closable, onClose, children }) => {
  const c = useColors();

  const [showNotification, setShowNotification] = useState(true);

  return (
    <>
      {showNotification && (
        <Stack direction="row" sx={{
          p: "4px 6px",
          background: c["brandLight75"],
          borderRadius: "4px",
        }}>
          <Stack direction="row" alignItems="center" sx={{
            p: "6px 6px 6px 0px",
          }}>
            <InfoOutlined style={{ color: c["brandDark50"], fontSize: "20px" }} />
          </Stack>
          <Stack direction="column" sx={{
            flexGrow: 1,
            p: "16px",
            background: c["greyLightFFF"],
            borderRadius: "4px",
          }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              {
                title ? <TextMAS>{(title) + ":"}</TextMAS> :
                  closable ? <span /> : null
              }
              {closable && (
                <Stack justifyContent="center" alignItems="center" sx={{
                  mr: "-4px",
                  mt: "-4px",
                  width: "32px",
                  height: "32px",
                  cursor: "pointer",
                }}
                  onClick={() => {
                    setShowNotification(false);
                    onClose && onClose();
                  }}
                >
                  <Close style={{ fontSize: "15px" }} />
                </Stack>
              )}
            </Stack>
            <Box sx={{
              wordWrap: "break-word",
              overflorWrap: "break-word",
              wordBreak: "break-word",
            }}>{children}</Box>
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default NoticeBox;
